<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
              <vs-button @click="goBack" color="danger" type="border" icon="keyboard_backspace">Back</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="12">
              <h3>Select Default Fields</h3>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
            </vs-col>
          </vs-row>
          <vs-divider class="p-5" />









          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6">
            </div>
            <div class="vx-col sm:w-1/6">
              <h5>Campaign:</h5>
            </div>
            <div class="vx-col sm:w-1/2">

              <CampaignAutocomplete :key="companySearchComponentKey" class="searchbox" :list="searchCampaign"
                :searchOn="'campaign'" @event-name="selectCampaign"></CampaignAutocomplete>


            </div>
            <span class="text-danger text-sm mt-2">{{
                please_choose_campaign
            }}</span>
          </div>



          <template v-if="account_columns.length != 0 && contact_columns != 0">

            <div class="text-center">
              <h4>Account Fields</h4>
              <h6 class="p-5">Select All <input class="ml-5" type="checkbox" v-model="allAccountFieldSelected"></h6>

            </div>


            <vs-row vs-w="12" class="mb-5">
              <vs-col class="p-5" v-for="account_column in account_columns" vs-type="flex" vs-lg="4" vs-sm="4"
                vs-xs="12">
                <input type="checkbox" v-model="selectedAccountFields"
                @change="selectAccountField(account_column)"
                  :value="account_column.column_id">
                <h6 class="p-5">{{ account_column.name }}</h6>
              </vs-col>
            </vs-row>

            <vs-divider class="m-5" />

            <div class="text-center">
              <h4>Contact Fields</h4>
              <h6 class="p-5">Select All <input class="ml-5" type="checkbox" v-model="allContactFieldSelected"></h6>

            </div>


            <vs-row vs-w="12" class="mb-5">
              <vs-col class="p-5" v-for="contact_column in contact_columns" vs-type="flex" vs-lg="4" vs-sm="4"
                vs-xs="12">


                <input type="checkbox" v-model="selectedContactFields" @change="selectContactField(contact_column)"
                  :value="contact_column.column_id">
                <h6 class="p-5">{{ contact_column.name }}</h6>
              </vs-col>
            </vs-row>

            <vs-divider class="m-5 " />

            <div class="vx-row mt-10">
              <div class="vx-col sm:w-1/6">
              </div>
              <div class="vx-col sm:w-1/6">
                <h5>Choose Comments:</h5>
              </div>
              <div class="vx-col sm:w-1/2">

                <ChooseCommentsAutocomplete :key="ChooseCommentsSearchComponentKey" class="searchbox"
                  :list="searchCommentField" :searchOn="'comment-fields'" @selectCommentField="selectCommentField">
                </ChooseCommentsAutocomplete>
                {{ selectedCommentField?selectedCommentField.name:'' }}
              </div>
              <span class="text-danger text-sm mt-2">{{
                  please_choose_comment_field
              }}</span>
            </div>







            <div class="text-center mt-10">
              <vs-button class="mr-3 mb-4" @click.prevent="submitForm">Submit</vs-button>
            </div>

          </template>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import ChooseCommentsAutocomplete from "@/components/autocomplete/ChooseCommentsAutocomplete.vue";
import vSelect from "vue-select";
export default {
  beforeMount() {
    // this.getDataSource();
  },
  data() {
    return {
      selectedCommentField: null,
      please_choose_comment_field: null,
      ChooseCommentsSearchComponentKey: 0,
      companySearchComponentKey: 0,
      account_columns: [],
      contact_columns: [],
      please_choose_campaign: null,
      selected_campaign: null,
      selected: [],
      abilities: null,
      allAccountFieldSelected: false,
      allContactFieldSelected: false,
      selectedAccountFields: [],
      selectedContactFields: [],
      defaultFields: {
        selected_campaign_id: null,
        selected_comment_field: null,
      },
    };
  },
  components: {
    "v-select": vSelect,
    DataGrid,
    CampaignAutocomplete,
    moduleCampaignManagement,
    ChooseCommentsAutocomplete
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];




    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  },
  mounted() {
  },
  watch: {
    allAccountFieldSelected: function (val) {
      let self = this;
      self.selectedAccountFields = [];
      if (val) {
        if (self.allAccountFieldSelected) {
          self.account_columns.forEach(function (e) {
            self.selectedAccountFields.push(e.column_id);
          })
        }

      }
    },
    allContactFieldSelected: function (val) {
      let self = this;
      self.selectedContactFields = [];
      if (val) {
        if (self.allContactFieldSelected) {
          self.contact_columns.forEach(function (e) {
            self.selectedContactFields.push(e.column_id);
          })
        }

      }
    }
  },
  methods: {
    searchCommentField(inputValue) {
      let filter = {};
      filter.campaign_id = this.selected_campaign.id;
      filter.search_term = inputValue;
      return this.$store
        .dispatch("campaignsManagement/searchCommentField", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.set_comment_field;
            if (data) {

               data =JSON.parse(data)
               console.log(data)


              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].column_id != "undefined") {
                  mappedArray.push({
                    id: data[property].column_id,
                    name: data[property].name
                  });
                }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    selectCommentField(value) {
      this.please_choose_comment_field = null;


      this.selected_comment_field = value
      this.selectedCommentField = this.selected_comment_field

    },
    selectAccountField(item) {

      this.account_columns.filter(function (column) {
        return column.column_id === item.column_id
      })
  
      // this.allAccountFieldSelected = false;
    },
    selectContactField(item) {

      this.contact_columns.filter(function (column) {
        return column.column_id === item.column_id
      })
      // this.allContactFieldSelected = false;
    },
    selectCampaign() {
      this.please_choose_campaign = null;
      this.selected_campaign = moduleCampaignManagement.state.campaign.datas;
      if (this.selected_campaign.length != 0) {
        this.selected_campaign = this.selected_campaign[0]
        this.fetchClientViewAccountFields();
        this.fetchClientViewContactFields();
        this.getAlreadySelectedDefaultFields()
      }
      console.log(this.selected_campaign)
    },
    getAlreadySelectedDefaultFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      self.$store
        .dispatch(
          "campaignsManagement/fetchAlreadySelectedDefaultFields",
          selected_campaign_id
        )
        .then(response => {
          let result = response.data
          self.selectedAccountFields = JSON.parse(result['account_fields']);
          self.selectedContactFields = JSON.parse(result['contact_fields']);
          self.selectedCommentField = JSON.parse(result['comment_field'])
        })
        .catch(err => {
          if (err.response.status === 401) {
            self.$router.replace("/login");
          }
        });
    },
    fetchClientViewAccountFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      this.$store
        .dispatch(
          "campaignsManagement/getAllAccountSelectedCampaignColumns",
          selected_campaign_id
        )
        .then(response => {
          this.account_columns = JSON.parse(response.data);


          this.account_columns.forEach(function(ele) {

            if (ele.column_id != 'account_status' && ele.column_id != 'account_sub_status' && ele.column_id != 'account_status_notes') {
              ele.column_id = '_' + ele.uuid.replaceAll("-", "_");

            }
            


  });





          console.log("Account Columns" ,this.account_columns)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    fetchClientViewContactFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      this.$store
        .dispatch(
          "campaignsManagement/getAllContactSelectedCampaignColumns",
          selected_campaign_id
        )
        .then(response => {
          this.contact_columns = JSON.parse(response.data);


          this.contact_columns.forEach(function(ele) {

            if (ele.column_id != 'contact_status' && ele.column_id != 'contact_sub_status' && ele.column_id != 'contact_status_notes' && ele.column_id != 'grade') {
              ele.column_id = '_' + ele.uuid.replaceAll("-", "_");

            }


});
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    searchCampaign(inputValue) {
      this.please_choose_client = null;

      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].campaign_name +
                      "  -   " +
                      data[property].campaign_code,
                    type: "campaign"
                  });
                }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    goBack: function () {
      this.$router.go(-1);
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.addDefaultFields();
        }
      });
    },
    addDefaultFields() {

      if (
        typeof this.selected_campaign !== "undefined" &&
        this.selected_campaign !== null
      ) {
        this.defaultFields.selected_campaign_id = this.selected_campaign.id;
      } else {
        this.please_choose_campaign = "The campaign field is required.";
        return false;
      }



      let selectedDefaultFields = {}
      selectedDefaultFields.selected_account_fields = this.selectedAccountFields
      selectedDefaultFields.selected_contact_fields = this.selectedContactFields


      if (this.selectedCommentField == null) {

        if (
          typeof this.selected_comment_field !== "undefined" &&
          this.selected_comment_field !== null
        ) {
          this.defaultFields.selected_comment_field = this.selected_comment_field.column_id;
        }
        else {
          this.please_choose_comment_field = "The comment field is required.";
          return false;
        }

        selectedDefaultFields.comment_field = this.selected_comment_field.column_id;


      } else {
        selectedDefaultFields.comment_field = this.selectedCommentField;

      }






      selectedDefaultFields.campaign_id = this.selected_campaign.id
      selectedDefaultFields.user_id = this.user_id;



      this.$store
        .dispatch("campaignsManagement/addDefaultFields", selectedDefaultFields)
        .then(res => {

          if (res.data.status = 'success') {

            this.$vs.notify({
              color: "success",
              title: "Default Fields Added",
              text: "The campaign default fields was added successfully"
            });
            location.reload();

          }



        })
        .catch(err => {
          console.log(err);

          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },

  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}

.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
